import React, { useState, useRef, useEffect } from "react";

const PopoverDropdown = ({ items = [], children , className}) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>

    <div onClick={() => setOpen((prev) => !prev)} className={`cursor-pointer`} onMouseEnter={() => setOpen(true)}>
      {children}
    </div>


      {open && (
        <div className={`absolute right-0 mt-2 w-48 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 z-10 ${className}`}>
          <div className="py-1">
            {items.map((item, index) => (
              <button
                key={index}
                onClick={() => {
                  setOpen(false);
                  item.onClick?.();
                }}
                className="block w-full text-left px-4 py-2 text-sm text-black hover:bg-gray-100"
              >
                {typeof item.label === "string" ? (
                  item.label
                ) : (
                  item.label
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PopoverDropdown;
